// Nutzereinstellungen → „Bots & API-Tokens" (Vertrag 1.6).
import type { ExtraContext } from '../index';
import { useQuery } from '@tanstack/react-query';
import { botsApi } from '../api';
import { botsKey } from './bots-utils';
import { BotsSection } from './BotsSection';
import { PersonalTokensSection } from './TokensSection';
import './bots.css';

export function BotsAndTokensSettings(_props: ExtraContext) {
  // Gleicher Schlüssel wie BotsSection → nur eine Anfrage; dient der Besitzer-Auswahl im Token-Dialog.
  const bots = useQuery({ queryKey: botsKey, queryFn: botsApi.list });
  return (
    <div className="lfx-stack lfx-bt" data-testid="bots-tokens-settings">
      <BotsSection />
      <PersonalTokensSection bots={bots.data} />
    </div>
  );
}
